<div
	class="journey__icon journey__icon--{{ status }}"
	freud-tooltip
	tooltipPosition="bottom"
	[tooltipLabel]="date === 'null' ? '' : date"
>
	<span
		*ngIf="status === 'completed'"
		class="freud-icon freud-icon-circle-check"
	></span>
	<span
		*ngIf="status === 'scheduled'"
		class="freud-icon freud-icon-clock"
	></span>
	<div *ngIf="status === 'suggested'">
		<span *ngIf="type === 'sessions'" class="journey__icon-text">
			{{ index }}º
		</span>
		<span
			*ngIf="type === 'contents'"
			class="freud-icon freud-icon-headphones gray-color"
		>
		</span>
		<span
			*ngIf="type === 'evaluations'"
			class="freud-icon freud-icon-list-check gray-color"
		>
		</span>
	</div>
</div>
